import './Footer.css'

const Footer = () => (
  <footer className='footer'>
    <a
      href='https://www.linkedin.com/in/syedsamiuddin96/'
      className='link footer__link'
    >
      &copy; Samiuddin Syed
    </a>
  </footer>
)

export default Footer
